import { map } from 'lodash';
import { FunctionComponent, useState } from 'react';
import GridLayout from 'react-grid-layout';
import { TemplateRenderer } from './DashboardViewer';
import { Button, Menu } from '@appd/uik';

interface Props {
  className: string;
  cols: number;
  rowHeight: number;
  containerPadding: [number, number];
  margin: [number, number];
  children: any[];
  width: number;
}

export const RGLGridLayout: FunctionComponent<Props> = props => {
  const initialLayout = map(props.children, function (child, i) {
    let childProps = child.props.gridItemProps;
    return {
      i: i.toString(),
      static: childProps?.static ? childProps.static : false,
      x: childProps.x,
      y: childProps.y,
      w: childProps.w,
      h: childProps.h,
    };
  });

  const [layout, setLayout] = useState<any[]>(initialLayout);

  const toggleFullScreen = (gridId: number) => {
    const newLayout = layout.map(item => {
      if (item.i === gridId.toString()) {
        return {
          ...item,
          x: 0,
          y: 0,
          w: props.cols,
          h: window.innerHeight / props.rowHeight,
        };
      } else {
        return {
          ...item,
          w: 0,
          h: 0,
        };
      }
    });
    setLayout(newLayout);
  };

  const createMenuTrigger = <Button icon="Navigation.MoreHorizontal" type="MENU"></Button>;

  const { Option } = Menu;

  const generateDOM = () => {
    return map(props.children, (child, i) => {
      const childLayoutProps = layout[i];
      const content = child.props.children[0].props;
      const [visibleBasic, setVisibleBasic] = useState<boolean>(false);
      return (
        <div
          key={i}
          className={childLayoutProps?.static ? 'static' : '' + ' bg-default-bg'}
          hidden={childLayoutProps.h == 0 && childLayoutProps.w == 0}
        >
          <TemplateRenderer name={content.name} props={content.props} childrenDef={content.childrenDef} />
          <div className="fixed top-0 right-0" hidden={childLayoutProps?.static}>
            <Menu
              onSelect={() => setVisibleBasic(false)}
              onVisibleChange={setVisibleBasic}
              trigger={createMenuTrigger}
              visible={visibleBasic}
            >
              <Option key={1}>
                <button type="button" className="w-full" onClick={() => toggleFullScreen(i)}>
                  View
                </button>
              </Option>
              <Option key={2}>
                <button type="button" className="w-full" onClick={() => setLayout(initialLayout)}>
                  Close
                </button>
              </Option>
            </Menu>
          </div>
        </div>
      );
    });
  };
  return (
    <GridLayout
      className={props.className}
      layout={layout}
      cols={props.cols}
      width={props.width}
      rowHeight={props.rowHeight}
      containerPadding={props.containerPadding}
      margin={props.margin}
    >
      {generateDOM()}
    </GridLayout>
  );
};
